import { combineReducers } from 'redux';

const helpListInistalState = {
  loadStatus: 0,
  list: null,
};

function helpsReducer(state = helpListInistalState, action) {
  switch (action.type) {
    case 'LOAD_HELP_LIST': {
      let list = state.list;

      return {
        ...state,
        loadStatus: 1,
        list,
      };
    }

    case 'LOAD_HELP_LIST_COMPLETION': {
      const { error, list } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list,
      };
    }

    default:
      return state;
  }
}

function helpReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_HELP_COMPLETION': {
      const { aid, error, data } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [aid]: data,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  helps: helpsReducer,
  help: helpReducer,
});
